import { render } from "./admin-login.vue?vue&type=template&id=66acfc35&scoped=true"
import script from "./admin-login.vue?vue&type=script&lang=js"
export * from "./admin-login.vue?vue&type=script&lang=js"

import "./admin-login.vue?vue&type=style&index=0&id=66acfc35&scoped=true&lang=css"

import exportComponent from "D:\\HbSave\\roc_web\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-66acfc35"]])

export default __exports__